import * as types from './mutation-types'

export default {
  [types.SET_CURRENT_RECURRENT_EXPENSE](state, data) {
    state.currentRecurrentExpense = data.recurrence
  }
}
